import { TableRows } from '@mui/icons-material';
import { Box } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { SolaForceHeading } from '~/components/SolaForceHeading';

import { Education } from '../data/index';

import { useSxStyles } from './useStyles';

type PropsType = {
  educationData?: Education[];
};
export const EducationTable = (props: PropsType) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  return (
    <Box component="table" sx={sxStyles.table}>
      <caption>
        <SolaForceHeading
          headingIcon={<TableRows />}
          heading={t('laEducation')}
        />
      </caption>
      <thead>
        <tr>
          <Box component="th" sx={sxStyles.thDegree}>
            {t('laDegree')}
          </Box>
          <Box component="th" sx={sxStyles.thInsti}>
            {t('laInstitution')}
          </Box>
          <Box component="th" sx={sxStyles.thSubject}>
            {t('laSubject')}
          </Box>
          <Box component="th" sx={sxStyles.thEndDate}>
            {t('laEndDate')}
          </Box>
        </tr>
      </thead>
      <tbody>
        {props.educationData?.map((eduData, index) => {
          return (
            <tr key={index}>
              <Box component="td" sx={sxStyles.td}>
                {eduData.fEduDegreeSubject}
              </Box>
              <Box component="td" sx={sxStyles.td}>
                {eduData.fEduDegreeInstitution}
              </Box>
              <Box component="td" sx={sxStyles.td}>
                {eduData.fEduDegreeSubject}
              </Box>
              <Box component="td" sx={sxStyles.td}>
                {moment(eduData.fEduDegreeEndDate).format('YYYY-MM-DD')}
              </Box>
            </tr>
          );
        })}
      </tbody>
    </Box>
  );
};
